import { Injectable } from '@angular/core';
import type { BillListQueryInterface } from '@zaoblako/shared/modules/document/dtos/bill/bill-list-query.dto';
import type { BillFindInterface } from '@zaoblako/shared/modules/document/dtos/bill/bill-find.dto';
import { BillPageQueryInterface } from '@zaoblako/shared/modules/document/dtos/bill/bill-page-query.dto';
import { BillPageInterface } from '@zaoblako/shared/modules/document/dtos/bill/bill-page.dto';
import { BillStatisticsInterface } from '@zaoblako/shared/modules/document/dtos/bill/bill-statistics.dto';
import type { BillVerifyQueryInterface } from '@zaoblako/shared/modules/document/dtos/bill/bill-verify-query.dto';
import type { BillVerifyResultItemInterface } from '@zaoblako/shared/modules/document/dtos/bill/bill-verify-result-item.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentBillService extends BaseService {
  protected baseUrl = '/finance/document/bill';

  public findWithPagination(queryParams: BillPageQueryInterface): Observable<BillPageInterface> {
    return this.http.get<BillPageInterface>(this.baseUrl, { params: this.objectToHttpParams(queryParams) });
  }

  public autocheck(queryParams: BillVerifyQueryInterface): Observable<BillVerifyResultItemInterface[]> {
    return this.http.get<BillVerifyResultItemInterface[]>(`${this.baseUrl}/verify`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getDebtorsBillsPdf(id: number): Observable<BlobPart> {
    return this.http.get<BlobPart>(`${this.baseUrl}/${id}/download`, {
      responseType: 'arraybuffer' as any
    });
  }

  public getAll(queryParams: BillListQueryInterface): Observable<BillFindInterface[]> {
    return this.http.get<BillFindInterface[]>(`${this.baseUrl}/all`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public statistics(queryParams: BillListQueryInterface): Observable<BillStatisticsInterface> {
    return this.http.get<BillStatisticsInterface>(`${this.baseUrl}/statistics`, {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
